import PadTab from './padsTab';

export default PadTab;
